import React from "react"
import {
  Box, Flex, Image, Text,
} from "@chakra-ui/react"
import arrowBack from "assets/images/phone/arrow-back.png"
import contact from "assets/images/phone/contact.png"
import StatusBar from "components/Phone/StatusBar"
import TextBubble from "./TextBubble"

type Props = {
  text: React.ReactNode
  phoneNumber: string
}

const SMSScreen = ({ text, phoneNumber }: Props) => (
  <Flex flexDir="column" h="100%">
    <Box bg="gray.100" pt={6} pb={2} borderBottomWidth={1}>
      <StatusBar />
      <Flex pt={6} pl={3.5}>
        <Image src={arrowBack} h={7} w="auto" />
      </Flex>
      <Flex flexDirection="column" mt={-6} alignItems="center" gap={1}>
        <Image src={contact} w={12} />
        <Text fontSize="xs">{phoneNumber}</Text>
      </Flex>
    </Box>
    <Box flex={1} p={6}>
      <TextBubble text={text} />
    </Box>
  </Flex>
)

export default SMSScreen
